import { useEffect, useRef } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import Layout from '../components/Layout'
import { trackSubscribe } from '../lib/adTracking'

// Landing after a successful Stripe Checkout. We do NOT flip member_status
// here — the webhook is the source of truth. This page just says thanks and
// invites the user back to their account, where the widget will have picked
// up the activation on the next profile refresh.
export default function MembersSuccess() {
  // Stripe sends the customer here once per successful checkout, so this is
  // the subscription conversion.
  //
  // `session_id` comes from the success_url ({CHECKOUT_SESSION_ID}) and is
  // what stops a page reload from booking a second conversion: Google
  // deduplicates on transaction_id. The ref only guards React 18's double
  // mount in dev.
  const [params] = useSearchParams()
  const sessionId = params.get('session_id') || ''
  const fired = useRef(false)
  useEffect(() => {
    if (fired.current) return
    fired.current = true
    trackSubscribe({ valueCents: 9500, subscriptionRef: sessionId })
  }, [sessionId])

  return (
    <Layout>
      <div className="flex flex-col items-center px-5 pb-12 pt-8 text-center">
        <div
          className="mb-4 flex h-20 w-20 items-center justify-center rounded-full text-[36px]"
          style={{ background: '#FEF6DF' }}
        >
          🏆
        </div>
        <h1 className="font-bricolage text-[22px] font-extrabold text-navy">
          Welcome to Ghost Members
        </h1>
        <p className="mt-2 max-w-xs text-[13px] leading-relaxed text-ink-2">
          Your subscription is confirmed. Priority pickups, 50 lbs included every
          4 weeks, next-day delivery.
        </p>
        <p className="mt-3 max-w-xs text-[11px] text-ink-3">
          It may take a few seconds for the activation to show up in your
          account.
        </p>
        <Link
          to="/account"
          className="mt-6 rounded-xl bg-navy px-6 py-3 font-bricolage text-[13px] font-extrabold text-white"
        >
          Back to my account
        </Link>
      </div>
    </Layout>
  )
}
